import React from "react";

import ClassementBarChart from "./ClassementBarChart";
import CombatResultsDonutChart from "./CombatResultsDonutChart";
import SeasonProgressChart from "./SeasonProgressChart";

function ChartCard({ title, description, children }) {
  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-4 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20 sm:p-5">
      <div className="mb-4">
        <h2 className="font-titre text-xl font-bold text-slate-950 dark:text-white">
          {title}
        </h2>

        {description && (
          <p className="mt-1 text-sm font-medium text-slate-500 dark:text-white/50">
            {description}
          </p>
        )}
      </div>

      {children}
    </article>
  );
}

function StatistiquesChartsGrid({ chartData, stats }) {
  return (
    <div className="mt-6 grid gap-5 xl:grid-cols-2">
      <ChartCard
        title="Résultats des combats"
        description={`Total analysé : ${stats.totalFights} combat${
          stats.totalFights > 1 ? "s" : ""
        }.`}
      >
        <CombatResultsDonutChart data={chartData.combatResults} />
      </ChartCard>

      <ChartCard
        title="Répartition des classements"
        description="Vision rapide des classements obtenus."
      >
        <ClassementBarChart data={chartData.classement} />
      </ChartCard>

      <div className="xl:col-span-2">
        <ChartCard
          title="Progression par saison sportive"
          description="Compétitions, combats, victoires et podiums par saison judo."
        >
          <SeasonProgressChart data={chartData.seasonal} />
        </ChartCard>
      </div>
    </div>
  );
}

export default StatistiquesChartsGrid;